import {
  OutboundSOAddProductDirectSliceType,
  setCheckItem,
  setItemQty,
} from 'features/SupplyOrder/redux/outboundSOAddProductDirect'
import { numberOnly, removeZeroOnFirst } from 'helpers'
import { useAppDispatch, useAppSelector } from 'store'

type RowType = {
  item: OutboundSOAddProductDirectSliceType['data'][0]
}

const useRow = ({ item }: RowType) => {
  const dispatch = useAppDispatch()

  const qty = useAppSelector(
    (state) =>
      state.outboundSOAddProductDirect.selectedItems[item.productUniqueKey]
        ?.productRequestQuantity ?? '',
  )

  const handleChangeCheckbox = () => {
    dispatch(setCheckItem(item.productUniqueKey))
  }

  const handleChangeQty = (value: string) => {
    const newValue = removeZeroOnFirst(numberOnly(value))
    dispatch(
      setItemQty({
        productUniqueKey: item.productUniqueKey,
        item: {
          productId: item.productId,
          productStock: item.productStock,
          productQrCode: item.productSku,
          productStatusId: item.productInventoryStatusId,
          productStatusNoteId: item.productInventoryStatusNoteId,
          productRequestQuantity: Number(newValue),
        },
      }),
    )
  }

  return {
    qty,
    handleChangeQty,
    handleChangeCheckbox,
  }
}

export default useRow
